import React, { Fragment } from 'react';
import styled from 'styled-components';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import { Button, Input } from '@yuhu-inc/yuhui';

import { getTranslatedString } from 'helpers/i18n';
import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { formatPhone } from 'helpers/Formatter';

const StyledText = styled.p`
  font-size: 18px;
  text-align: left;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  float: ${(props) => (props.float ? props.float : 'left')};
  margin-bottom: 0;
`;

const StyledLinkButton = styled(Button)`
  background: none;
  border: none;
  font-weight: bold;
  color: ${AccentColor()};
  margin: 0;
  padding: 0;
`;

const StyledRightText = styled.p`
  font-size: 18px;
  text-align: left;
  font-weight: bold;
  float: right;
  margin-bottom: 0;
`;

const StyledSmallHeader = styled.p`
  font-size: 14px;
  text-align: ${(props) => (props.rightAlign ? 'right' : 'left')};
  margin-bottom: 0;
  color: #828282;
`;

const StyledHR = styled.hr`
  margin: 10px 0;
`;

const StyledErrorP = styled.p`
  color: ${colors.YUHU_RED};
`;

const StyledRowMarginTop = styled(Row)`
  margin-top: 30px;
`;

const TenantDetailsCard = ({
  tenant,
  clearEmail,
  editedEmail,
  editEmail,
  editEmailError = null,
}) => {
  return (
    <Fragment>
      <Row gutter={16}>
        <Col span={12}>
          <StyledText bold>{tenant.full_name}</StyledText>
        </Col>
        <Col span={12}>
          <StyledRightText>
            {getTranslatedString('landlordPortal.dashboard.unitNumber', {
              unit: tenant.lease.unit_number,
            })}
          </StyledRightText>
        </Col>
      </Row>
      <StyledHR />
      <Row gutter={16}>
        <Col span={8}>
          <StyledSmallHeader>
            {getTranslatedString('landlordPortal.dashboard.propertyName')}
          </StyledSmallHeader>
          <p>{tenant.lease.property_name}</p>
        </Col>
        <Col span={8}>
          <StyledSmallHeader>
            {getTranslatedString('landlordPortal.dashboard.phoneNumber')}
          </StyledSmallHeader>
          <p>{formatPhone(tenant.phone_number)}</p>
        </Col>
        <Col span={8}>
          <StyledSmallHeader rightAlign={true}>
            {getTranslatedString('landlordPortal.dashboard.leaseId')}
          </StyledSmallHeader>
          <p style={{ textAlign: 'right' }}>{tenant.lease.client_external_id}</p>
        </Col>
      </Row>
      <StyledRowMarginTop gutter={16}>
        <Col span={24}>
          <StyledText bold>
            {getTranslatedString('landlordPortal.dashboard.modifyEmail')}
          </StyledText>
        </Col>
        <Col span={24}>
          <p>{getTranslatedString('landlordPortal.dashboard.keepThisResident')}</p>
          <StyledSmallHeader>
            {getTranslatedString('landlordPortal.dashboard.email')}
          </StyledSmallHeader>
          <Input
            value={editedEmail}
            onChange={(e) => editEmail(e.target.value)}
            type="email"
            placeholder="email@email.com"
          />
          {editEmailError && <StyledErrorP>{editEmailError}</StyledErrorP>}
        </Col>
      </StyledRowMarginTop>
      <StyledRowMarginTop gutter={16}>
        <Col span={24}>
          <StyledText bold>
            {getTranslatedString('landlordPortaldashboard.removeThisEmail')}
          </StyledText>
        </Col>
        <Col span={24}>
          <p>{getTranslatedString('landlordPortal.dashboard.removeThisEmailFromResident')}</p>
          <StyledLinkButton
            onClick={clearEmail}
            contentKey="landlordPortal.dashboard.removeEmail"
          />
        </Col>
      </StyledRowMarginTop>
    </Fragment>
  );
};

export default TenantDetailsCard;
